import React, { useContext } from "react";

import { Error, Info, Warn } from "@churchofjesuschrist/eden-alert";
import { Primary, Secondary } from "@churchofjesuschrist/eden-buttons";
import {Details, Summary} from "@churchofjesuschrist/eden-details";
import { Row } from "@churchofjesuschrist/eden-row";
import { Stack } from "@churchofjesuschrist/eden-stack";
import {
  borderColorTertiary as borderColor,
  spacing24 as gap,
  spacing8,
} from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import MobileViewContext from "../../global-layout/mobile/mobile-view-context";
import useManagedStrings from "../../utils/use-managed-strings";
import AlertMessageDisplay from "../alert-message-display/alert-message-display";

const ShadowlessWarn = styled(Warn)`
  border-top: solid 1px ${borderColor}!important;
  border-bottom: solid 1px ${borderColor} !important;
  border-right: solid 1px ${borderColor}!important;
  box-shadow: none;
  > div {
    width: 100%;
  }
`;
const ShadowlessError = styled(Error)`
  border-top: solid 1px ${borderColor}!important;
  border-bottom: solid 1px ${borderColor}!important;
  border-right: solid 1px ${borderColor}!important;
  box-shadow: none;
  > div {
    width: 100%;
  }
`;
const ShadowlessInfo = styled(Info)`
  border-top: solid 1px ${borderColor}!important;
  border-bottom: solid 1px ${borderColor}!important;
  border-right: solid 1px ${borderColor}!important;
  box-shadow: none;
  > div {
    width: 100%;
  }
`;

const ContentFlex = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`;
const ContentLeft = styled.div`
  margin-right: ${gap};
  flex: 1;
`;

const ContentRight = styled.div`
  display: grid;
  grid-template-areas:
    "top"
    "middle"
    "bottom";
`;
const Top = styled.div`
  grid-area: "top";
`;
const Middle = styled.div`
  display: flex;
  grid-area: "middle";
`;
const MiddleRow = styled(Row)`
  width: 100%;
  min-width: 300px;
  flex-direction: row-reverse;
`;
const MobileStack = styled(Stack)`
  margin-top:${spacing8};
`;
const Bottom = styled.div`
  grid-area: "bottom";
`;

const H3 = styled.h3`
  margin: 0;
`;
const stringGroups = [
  {
    name: "admin",
    keys: ["tempDismissAlert", "fullDismissAlert"],
  },
];


const InnerContent = ({
  alert = { type: "attendance" },
  onDismiss = () => {},
  onDelete = () => {},
  dismissable = true,
}) => {
  const { managedStrings: useStrings } = useManagedStrings(stringGroups);
  const { isMobile } = useContext(MobileViewContext);

  const Container = isMobile ? MobileStack : MiddleRow;

  return isMobile ? (<Details data-id={`alert-${alert.id}-mobile`}>
    <Summary>
      <H3 type={alert.type} data-id="heading">{alert.subject}</H3>
    </Summary>
    <Container>
      <AlertMessageDisplay alert={alert} />
      <Secondary
        onClick={() => onDelete(alert)}
        data-id={`alert-delete-${alert.id}`}
      >
        {useStrings.fullDismissAlert}
      </Secondary>
      {dismissable ? (
        <Primary
          onClick={() => onDismiss(alert)}
          data-id={`alert-hide-${alert.id}`}
        >
          {useStrings.tempDismissAlert}
        </Primary>
      ) : null}
    </Container>
  </Details>) : (
    <ContentFlex data-id={`alert-${alert.id}`}>
      <ContentLeft>
        <Stack>
          <H3 type={alert.type} data-id="heading">{alert.subject}</H3>
          <AlertMessageDisplay alert={alert} />
        </Stack>
      </ContentLeft>

      <ContentRight>
        <Top></Top>
        <Middle>
          <Container verticalAlign="center" align="space-between">
            <Secondary
              onClick={() => onDelete(alert)}
              data-id={`alert-delete-${alert.id}`}
            >
              {useStrings.fullDismissAlert}
            </Secondary>
            {dismissable ? (
              <Primary
                onClick={() => onDismiss(alert)}
                data-id={`alert-hide-${alert.id}`}
              >
                {useStrings.tempDismissAlert}
              </Primary>
            ) : null}
          </Container>
        </Middle>
        <Bottom></Bottom>
      </ContentRight>
    </ContentFlex>
  );
};

const SystemAlertUserDisplay = (props) => {
  const { alert = { type: "attendance" } } = props;
  const atype = alert?.type?.toLowerCase() ?? "";
  let Use =
    atype === "custom"
      ? ShadowlessInfo
      : alert.type === "downtime"
        ? ShadowlessWarn
        : ShadowlessError;
  return <Use>{InnerContent(props)}</Use>;
};

export default SystemAlertUserDisplay;
